import classNames from 'classnames';
import React, { Component, Fragment } from 'react';

import { getPlansByCommitmentLevel } from 'utils/stripePlanUtils';

import { PLAN_LIMIT } from 'config/constants';

import 'pages/student/Activate/ActivateSubscription/style.css';
import '../style.css';

const LESSON_FREQUENCY_AND_LIMIT = [
  {
    frequency: 'Daily',
    limit: PLAN_LIMIT.HOURS_15
  },
  {
    frequency: '2 lessons',
    limit: PLAN_LIMIT.HOURS_4
  },
  {
    frequency: '4 lessons',
    limit: PLAN_LIMIT.HOURS_8
  }
];

class SelectPlan extends Component {
  handlePlanClick = (availablePlan) => {
    this.props.onPlanSelect(availablePlan);
  }

  renderAvailablePlan(availablePlan, frequency) {
    const className = classNames('activate-content__schedule-wrapper',
      { 'activate-content__activate': availablePlan.id === this.props.selectedPlan.id });
    return (
      <div key={availablePlan.id} onClick={() => this.handlePlanClick(availablePlan)} className="col px-0">
        <div className={className}>
          <div className="activate-content__schedule">
            <div>
              <p className="activate-content__shared-period-title">{frequency}</p>
            </div>
            {availablePlan.limit === PLAN_LIMIT.HOURS_15 ? (
              <div className="mb-1">
                <span className="activate-content__schedule-span-best">Best Value</span>
              </div>
            ) : (
              <div>
                <small className="activate-content__schedule-span">
                  /week
                </small>
              </div>
            )}
          </div>
          <div className="activate-content__schedule-hours align-items-center">
            <div><h6 className="activate-content__schedule-title">{availablePlan.limit} hours</h6></div>
            <div><h6 className="activate-content__schedule-sub-title">per month</h6></div>
          </div>
        </div>
      </div>
    );
  }

  renderCommitmentExplanation() {
    return (
      <div className="activate-content__general-explanation mt-3">
        <p className="activate-content__general-explanation__title">Commitment level</p>
        <p className="activate-content__general-explanation__sub-title">Cancel or pause any time.</p>
      </div>
    );
  }

  render() {
    const { selectedPlan } = this.props;
    /*
     * `getPlansByCommitmentLevel` checks selected plan's commitment level and returns one of the following;
     * * 3 annual plan
     * * 3 monthly plan
     */
    const filteredPlansByCommitmentLevel = getPlansByCommitmentLevel(selectedPlan);
    return (
      <Fragment>
        <div className="period-select">
          {filteredPlansByCommitmentLevel.map(plan => {
            const planFeatures = LESSON_FREQUENCY_AND_LIMIT.find(frequencyGroup => {
              return frequencyGroup.limit === plan.limit;
            });
            return this.renderAvailablePlan(plan, planFeatures.frequency);
          })}
        </div>
        {this.renderCommitmentExplanation()}
        <div className="period-select">
          {this.props.children}
        </div>
      </Fragment>
    );
  }
}

export default SelectPlan;



// WEBPACK FOOTER //
// ./src/components/PlanSelect/SelectPlan/index.js